import React from 'react';
import { string, oneOf, bool } from 'prop-types';
import cx from 'classnames';

const CLASS_ROOT = 'article__item';

const propTypes = {
  tag: string,
  type: oneOf(['header']),
  negativeTop: bool,
};

const ArticleItem = ({
  className,
  children,
  tag = 'div',
  type,
  negativeTop,
  ...other
}) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`article__${type}`]: type,
      [`${CLASS_ROOT}--negative-top`]: negativeTop,
    },
    'container',
    className,
  );

  let Tag = tag;

  if (type === 'header') {
    Tag = 'header';
  }

  return (
    <Tag className={classes} {...other}>
      {children}
    </Tag>
  );
};

ArticleItem.propTypes = propTypes;

export default ArticleItem;
